import React from "react";

import { isNormalizedIdentifierMatch } from "../../utils/railCarUtils";

import { IdentifierVerificationDialog } from "./IdentifierVerificationDialog";

/** Container # verification: same normalization as {@link isNormalizedIdentifierMatch}. */
export const matchContainerNumberToExpected = (expected, entered) =>
  isNormalizedIdentifierMatch(expected, entered);

export const ContainerNumberDialog = ({
  containerNumber,
  close,
  onProceed,
  open,
  scanEnabled = false,
  onValidationSuccess = null,
}) => {
  const handleValidationSuccess = onValidationSuccess ?? close;

  return (
    <IdentifierVerificationDialog
      open={open}
      title="Validate Container Number"
      fieldLabel="Container Number"
      expectedIdentifier={containerNumber}
      valuesMatch={matchContainerNumberToExpected}
      successNotifyMessage="Container # validated successfully"
      mismatchHelperText="Container number does not match. You can proceed if needed."
      mismatchWarningNotify="Container number does not match. You can proceed if needed."
      validateAriaLabel="Validate container number"
      inputAriaLabel="Enter container number"
      allowExceptionOnMismatch={Boolean(onProceed)}
      onProceedWithException={onProceed}
      scanEnabled={scanEnabled}
      onClose={close}
      onValidationSuccess={handleValidationSuccess}
    />
  );
};
